import React from 'react';
import SignatureCanvas from 'react-signature-canvas';

import Loading from '../Loading/Loading';
import {
	SignaturePadContainer,
	Chip,
	CanvasWrapper,
	InputContainer,
	TextArea,
	Actions
} from './SignaturePad.styles';

function SignaturePad({
	loading,
	signatureType,
	signatureText,
	onChangeSignatureType,
	onChangeSignatureText,
	handleKeyDown,
	canvasOptions,
	getCanvasRef,
	textCanvasRef,
	onClear,
	onUndo
}) {
	const isTextSignature = signatureType === 'TEXT';

	return (
		<SignaturePadContainer className="doca">
			{loading && <Loading />}

			{!loading && (
				<>
					<div className="doca-mb-4 doca-flex doca-flex-row doca-gap-2">
						<Chip
							className="doca-flex doca-items-center doca-gap-2 doca-cursor-pointer doca-text--normal doca-px-4 doca-py-2"
							active={isTextSignature}
							onClick={() => onChangeSignatureType('TEXT')}
						>
							<i className="doca-icon doca-icon__keyboard doca-icon--light" />
							Manual
						</Chip>
						<Chip
							className="doca-flex doca-items-center doca-gap-2 doca-cursor-pointer doca-text--normal doca-px-4 doca-py-2"
							active={!isTextSignature}
							onClick={() => onChangeSignatureType('CANVAS')}
						>
							<i className="doca-icon doca-icon__signature doca-icon--light" />
							Rúbrica
						</Chip>
					</div>

					{signatureType === 'CANVAS' && (
						<CanvasWrapper className="doca-w-full doca-bg-white">
							<SignatureCanvas
								ref={getCanvasRef}
								canvasProps={{
									width: 500,
									height: 212,
									className: 'doca-w-full doca-h-full'
								}}
							/>
						</CanvasWrapper>
					)}

					{signatureType === 'TEXT' && (
						<>
							<InputContainer className="doca-w-full doca-mb-2">
							<canvas
								hidden
								width={canvasOptions.width}
								height={canvasOptions.height}
								ref={textCanvasRef}
							/>
								<TextArea
									className="doca-w-full doca-text--center"
									value={signatureText}
									maxLength={60}
									onChange={onChangeSignatureText}
									onKeyDown={handleKeyDown}
									placeholder="Digite aqui"
								/>
							</InputContainer>
						</>
					)}

					<Actions>
						<button className="doca-button doca-button--secondary doca-mr-2" onClick={onClear}>
							<i className="doca-icon doca-icon__trash" />
							Limpar
						</button>

						{signatureType === 'CANVAS' && (
							<button className="doca-button doca-button--secondary" onClick={onUndo}>
								<i className="doca-icon doca-icon__undo" />
								Desfazer
							</button>
						)}
					</Actions>
				</>
			)}
		</SignaturePadContainer>
	);
}

export default SignaturePad;
